import Modal from "../shared/Modal";
import { Button } from "../../ds2/components";
import "./ModalDisconnectHrisConfirm.css";

type ModalDisconnectHrisConfirmProps = {
  isOpen: boolean;
  onClose: () => void;
  onContinue: () => void;
};

const ModalDisconnectHrisConfirm = ({
  isOpen,
  onClose,
  onContinue,
}: ModalDisconnectHrisConfirmProps) => {
  if (!isOpen) {
    return null;
  }

  return (
    <Modal
      isOpen={isOpen}
      style={null}
      onClose={onClose}
      canClose={false}
      allowClickout={true}>
      <div id="modal-disconnect-hris-confirm">
        <div className="modal-disconnect-hris-confirm-title">
          Disconnect HRIS Integration
        </div>

        <div className="modal-disconnect-hris-confirm-content">
          Are you sure you want to disconnect your HRIS integration? This will
          remove access to employee data and related features. You can reconnect
          at any time through the workspace settings.
        </div>

        <div className="modal-disconnect-hris-confirm-footer">
          <div className="modal-disconnect-hris-confirm-buttons">
            <Button
              variant="secondary"
              onClick={onClose}>
              Cancel
            </Button>
            <Button
              variant="primary"
              onClick={() => onContinue()}>
              Disconnect
            </Button>
            
            {/* <button onClick={onClose} className="collections-button-negative">
              Cancel
            </button>
            <button onClick={() => onContinue()} className="collections-button">
              Disconnect
            </button> */}
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ModalDisconnectHrisConfirm;
